import React from "react";
import { Box, Typography, Grid, Card, Container } from "@mui/material";

const IndustryChallenges = (props) => {
  return (
    <Box
      sx={{
        p: 4,
        bgcolor: "transparent",
      }}
    >
      <Container>
        <Typography variant="h4" fontWeight="bold" gutterBottom sx={{ color: "#DADFEF", textAlign: "center" }}>
          Industry Challenges & Our Solutions
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {props?.solutions.map((item, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  borderRadius: 3,
                  border: "2px solid #a685f3",
                  bgcolor: "#B6BFE0",
                  p:1,
                  mt:3
                }}
              >
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  sx={{
                    bgcolor: "#5F2FC0",
                    color: "white",
                    p: 1,
                    borderRadius: 2,
                    mb: 1,
                    alignItems:"center",
                    display:"flex",
                    border: "4px solid #DADFEF",
                    padding:1,
                    height:"70px"
                  }}
                >
                  {item.title}
                </Typography>
                <Box sx={{border: "4px solid #DADFEF",borderRadius: 3, height:"200px"}}>
                  <Typography
                    variant="body1"
                    sx={{
                      bgcolor: "#C83737",
                      color: "white",
                      p: 1,
                      borderTopRightRadius: 10,
                      borderTopLeftRadius: 10,
                      height:"100px"
                    }}
                  >
                    <strong>The Problem:</strong> {item.problem}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      bgcolor: "#2F9238",
                      color: "white",
                      p: 1,
                      borderBottomRightRadius: 10,
                      borderBottomLeftRadius: 10,
                      height:"100px"
                    }}
                  >
                    <strong>Our Solution:</strong> {item.solution}
                  </Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default IndustryChallenges;